import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0623bfa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-page" }
const _hoisted_2 = { class: "wrap-header" }
const _hoisted_3 = { class: "wrap-main" }
const _hoisted_4 = {
  key: 0,
  class: "wrap-cont"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "cont-first" }
const _hoisted_7 = { class: "control-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "一键控制")
], -1))
const _hoisted_9 = { class: "item-main flex-nowrap" }
const _hoisted_10 = { class: "control-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-touyingyi01" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "投影仪控制")
], -1))
const _hoisted_12 = { class: "item-main flex-nowrap" }
const _hoisted_13 = { class: "control-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-kaiguan" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "开关控制")
], -1))
const _hoisted_15 = { class: "item-main" }
const _hoisted_16 = { class: "control-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shipin" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "视频输入")
], -1))
const _hoisted_18 = { class: "item-main" }
const _hoisted_19 = {
  key: 0,
  class: "control-item"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "电源箱")
], -1))
const _hoisted_21 = { class: "item-main" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "cont-first" }
const _hoisted_25 = { class: "control-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "一键控制")
], -1))
const _hoisted_27 = { class: "item-main flex-nowrap" }
const _hoisted_28 = { class: "control-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-touyingyi01" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "投影仪控制")
], -1))
const _hoisted_30 = { class: "item-main flex-nowrap" }
const _hoisted_31 = { class: "control-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-kaiguan" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "开关控制")
], -1))
const _hoisted_33 = { class: "item-main" }
const _hoisted_34 = { class: "control-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shipin" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "视频输入")
], -1))
const _hoisted_36 = { class: "item-main" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span-fs" }, "笔记本", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span-fs" }, "HDMI", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span-fs" }, "笔记本", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span-fs" }, "VGA", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "control-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shipin" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "视频输出")
], -1))
const _hoisted_45 = { class: "item-main" }
const _hoisted_46 = {
  key: 0,
  class: "control-item"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "电源箱")
], -1))
const _hoisted_48 = { class: "item-main" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { class: "cont-first" }
const _hoisted_52 = { class: "control-item" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "一键控制")
], -1))
const _hoisted_54 = { class: "item-main flex-nowrap" }
const _hoisted_55 = { class: "control-item" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-touyingyi01" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "投影仪控制")
], -1))
const _hoisted_57 = { class: "item-main flex-nowrap" }
const _hoisted_58 = { class: "control-item" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-kaiguan" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "开关控制")
], -1))
const _hoisted_60 = { class: "item-main" }
const _hoisted_61 = {
  key: 0,
  class: "control-item"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "电源箱")
], -1))
const _hoisted_63 = { class: "item-main" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { key: 3 }
const _hoisted_66 = { class: "cont-first" }
const _hoisted_67 = { class: "control-item" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "一键控制")
], -1))
const _hoisted_69 = { class: "item-main flex-nowrap" }
const _hoisted_70 = { class: "control-item" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-touyingyi01" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "投影仪控制")
], -1))
const _hoisted_72 = { class: "item-main flex-nowrap" }
const _hoisted_73 = { class: "control-item" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-kaiguan" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "开关控制")
], -1))
const _hoisted_75 = { class: "item-main" }
const _hoisted_76 = { class: "control-item" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shipin" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "同显模式")
], -1))
const _hoisted_78 = { class: "item-main" }
const _hoisted_79 = {
  key: 0,
  class: "control-item"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shipin" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "异显模式")
], -1))
const _hoisted_81 = { class: "item-main" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { key: 4 }
const _hoisted_84 = { class: "control-item" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "一键控制")
], -1))
const _hoisted_86 = { class: "item-main flex-nowrap" }
const _hoisted_87 = { class: "control-item" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-touyingyi01" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "投影仪")
], -1))
const _hoisted_89 = { class: "item-main flex-nowrap" }
const _hoisted_90 = { class: "control-item" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-kaiguan" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "开关控制")
], -1))
const _hoisted_92 = { class: "item-main" }
const _hoisted_93 = { class: "control-item" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shipin" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "投影机显示")
], -1))
const _hoisted_95 = { class: "item-main" }
const _hoisted_96 = { class: "control-item" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shipin" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "音视频输出")
], -1))
const _hoisted_98 = { class: "item-main" }
const _hoisted_99 = { class: "control-item" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "幕布控制")
], -1))
const _hoisted_101 = { class: "item-main flex-nowrap" }
const _hoisted_102 = { key: 5 }
const _hoisted_103 = { class: "cont-first" }
const _hoisted_104 = { class: "control-item" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "一键控制")
], -1))
const _hoisted_106 = { class: "item-main flex-nowrap" }
const _hoisted_107 = { class: "control-item" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-touyingyi01" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "投影仪")
], -1))
const _hoisted_109 = { class: "item-main flex-nowrap" }
const _hoisted_110 = { class: "control-item" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-kaiguan" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "锁控制")
], -1))
const _hoisted_112 = { class: "item-main" }
const _hoisted_113 = { class: "control-item" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "电脑控制")
], -1))
const _hoisted_115 = { class: "item-main" }
const _hoisted_116 = { class: "control-item" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shipin" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "视频通道")
], -1))
const _hoisted_118 = { class: "item-main" }
const _hoisted_119 = { class: "control-item" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-chuanglian" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "幕布控制")
], -1))
const _hoisted_121 = { class: "item-main" }
const _hoisted_122 = { class: "control-item" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "音量控制")
], -1))
const _hoisted_124 = { class: "item-main" }
const _hoisted_125 = { key: 6 }
const _hoisted_126 = { class: "control-item" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-a-ziyuan61" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs28" }, "一键控制")
], -1))
const _hoisted_128 = { class: "item-main flex-nowrap" }
const _hoisted_129 = {
  key: 1,
  class: "wrap-cont"
}
const _hoisted_130 = {
  key: 0,
  class: "wrap-item"
}
const _hoisted_131 = { class: "item-left" }
const _hoisted_132 = { class: "item-title" }
const _hoisted_133 = { class: "fs28" }
const _hoisted_134 = { class: "item-right" }
const _hoisted_135 = ["onClick"]
const _hoisted_136 = ["onClick"]
const _hoisted_137 = {
  key: 2,
  class: "wrap-cont"
}
const _hoisted_138 = { class: "wrap-environment" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "environment-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-shidu" }),
  /*#__PURE__*/_createElementVNode("div", { class: "fs28" }, "环境参数")
], -1))
const _hoisted_140 = { class: "environment-main" }
const _hoisted_141 = {
  key: 0,
  class: "en-item"
}
const _hoisted_142 = {
  key: 1,
  class: "en-item"
}
const _hoisted_143 = {
  key: 2,
  class: "en-item"
}
const _hoisted_144 = {
  key: 3,
  class: "en-item"
}
const _hoisted_145 = {
  key: 4,
  class: "en-item"
}
const _hoisted_146 = {
  key: 5,
  class: "en-item"
}
const _hoisted_147 = {
  key: 6,
  class: "en-item"
}
const _hoisted_148 = {
  key: 7,
  class: "en-item"
}
const _hoisted_149 = {
  key: 3,
  class: "wrap-cont"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_head_top = _resolveComponent("head-top")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_Guard = _resolveComponent("Guard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_head_top, {
      title: $data.className,
      showBack: $data.showBack
    }, null, 8, ["title", "showBack"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_tabs, {
        active: $data.cur,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($data.cur) = $event)),
        color: "#2F7DFF",
        "title-active-color": "#2F7DFF",
        scrollspy: true,
        sticky: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tab, {
            title: "终端管控",
            name: "1"
          }),
          ($data.showIOT)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 0,
                title: "物联网管控",
                name: "2"
              }))
            : _createCommentVNode("", true),
          ($data.sensorInfo)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 1,
                title: "环境参数",
                name: "3"
              }))
            : _createCommentVNode("", true),
          ($data.showGuard)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 2,
                title: "门禁管控",
                name: "4"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      ($data.cur == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600QH' || $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3000QH')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 3 || $data.TerminalInfo.Info.State === 'Opened')
                      ? 'active'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 2 || $data.TerminalInfo.Info.State === 'Opening')
                      ? 'active-ing'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 0 || $data.TerminalInfo.Info.State === 'Shutdown')
                      ? 'unActive'
                      : ''
                  ]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.Control('sceneOnClass')))
                        }, " 上课 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 1 || $data.TerminalInfo.Info.State === 'ShuttingDown')
                      ? 'active-ing'
                      : ''
                  ]),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.Control('sceneOffClass')))
                        }, " 下课 ", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0].State &&
                    ($data.TerminalInfo.Info.Projectors[0].State === 1 || $data.TerminalInfo.Info.Projectors[0].State === 'On')
                      ? 'active'
                      : ''
                  ]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (
                    $options.Control(
                      'projectorer1',
                      $data.TerminalInfo.Info && $data.TerminalInfo.Info.Projectors && $data.TerminalInfo.Info.Projectors[0].State ? 0 : 1
                    )
                  ))
                        }, " 投影一 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[1].State &&
                    ($data.TerminalInfo.Info.Projectors[1].State === 1 || $data.TerminalInfo.Info.Projectors[1].State === 'On')
                      ? 'active'
                      : ''
                  ]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (
                    $options.Control(
                      'projectorer2',
                      $data.TerminalInfo.Info && $data.TerminalInfo.Info.Projectors && $data.TerminalInfo.Info.Projectors[1].State ? 0 : 1
                    )
                  ))
                        }, " 投影二 ", 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.PanelLock === 1 || $data.TerminalInfo.Info.PanelLock === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.Control('PanelLock', $data.TerminalInfo.Info.PanelLock ? 0 : 1)))
                      }, " 面板锁 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.ELock === 1 || $data.TerminalInfo.Info.ELock === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.Control('E_Lock', $data.TerminalInfo.Info.ELock ? 0 : 1)))
                      }, " 讲台锁 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.Arming === 1 || $data.TerminalInfo.Info.Arming === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.Control('Arming', $data.TerminalInfo.Info.Arming ? 0 : 1)))
                      }, " 终端警报 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.Guard === 1 || $data.TerminalInfo.Info.Guard === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.Control('Guard', $data.TerminalInfo.Info.Guard ? 0 : 1)))
                      }, " 门禁 ", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoIns &&
                  $data.TerminalInfo.Info.VideoIns[0] &&
                  ($data.TerminalInfo.Info.VideoIns[0] === 1 || $data.TerminalInfo.Info.VideoIns[0] === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (
                  $options.Control(
                    'Video_0',
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoIns && $data.TerminalInfo.Info.VideoIns[0] ? 0 : 1
                  )
                ))
                      }, " 睿课终端 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoIns &&
                  $data.TerminalInfo.Info.VideoIns[1] &&
                  ($data.TerminalInfo.Info.VideoIns[1] === 1 || $data.TerminalInfo.Info.VideoIns[1] === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (
                  $options.Control(
                    'Video_1',
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoIns && $data.TerminalInfo.Info.VideoIns[1] ? 0 : 1
                  )
                ))
                      }, " VGA ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoIns &&
                  $data.TerminalInfo.Info.VideoIns[2] &&
                  ($data.TerminalInfo.Info.VideoIns[2] === 1 || $data.TerminalInfo.Info.VideoIns[2] === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (
                  $options.Control(
                    'Video_2',
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoIns && $data.TerminalInfo.Info.VideoIns[2] ? 0 : 1
                  )
                ))
                      }, " 电脑 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoIns &&
                  $data.TerminalInfo.Info.VideoIns[3] &&
                  ($data.TerminalInfo.Info.VideoIns[3] === 1 || $data.TerminalInfo.Info.VideoIns[3] === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (
                  $options.Control(
                    'Video_3',
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoIns && $data.TerminalInfo.Info.VideoIns[3] ? 0 : 1
                  )
                ))
                      }, " 笔记本 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoIns &&
                  $data.TerminalInfo.Info.VideoIns[4] &&
                  ($data.TerminalInfo.Info.VideoIns[4] === 1 || $data.TerminalInfo.Info.VideoIns[4] === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (
                  $options.Control(
                    'Video_4',
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoIns && $data.TerminalInfo.Info.VideoIns[4] ? 0 : 1
                  )
                ))
                      }, " 网关 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoIns &&
                  $data.TerminalInfo.Info.VideoIns[5] &&
                  ($data.TerminalInfo.Info.VideoIns[5] === 1 || $data.TerminalInfo.Info.VideoIns[5] === 'On')
                    ? 'active'
                    : ''
                ]),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (
                  $options.Control(
                    'Video_5',
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoIns && $data.TerminalInfo.Info.VideoIns[5] ? 0 : 1
                  )
                ))
                      }, " 拓展 ", 2)
                    ])
                  ]),
                  ($data.Powers.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Powers, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["item-option", item.Value === 'On' || item.Value === 1 ? 'active' : '']),
                              key: index,
                              onClick: 
                  () =>
                    item.ID === 11 || item.ID === 23 || item.ID === 24 || item.ID === 53 || item.ID === 54
                      ? null
                      : $options.Control(`Power_${item.ID}`, item.Value ? 0 : 1)
                
                            }, _toDisplayString(item.Name), 11, _hoisted_22))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600JZ')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 3 || $data.TerminalInfo.Info.State === 'Opened')
                      ? 'active'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 2 || $data.TerminalInfo.Info.State === 'Opening')
                      ? 'active-ing'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 0 || $data.TerminalInfo.Info.State === 'Shutdown')
                      ? 'unActive'
                      : ''
                  ]),
                            onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.Control('sceneOnClass')))
                          }, " 上课 ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 1 || $data.TerminalInfo.Info.State === 'ShuttingDown')
                      ? 'active-ing'
                      : ''
                  ]),
                            onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.Control('sceneOffClass')))
                          }, " 下课 ", 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0].State &&
                    ($data.TerminalInfo.Info.Projectors[0].State === 1 || $data.TerminalInfo.Info.Projectors[0].State === 'On')
                      ? 'active'
                      : ''
                  ]),
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (
                    $options.Control(
                      'projectorer1',
                      $data.TerminalInfo.Info && $data.TerminalInfo.Info.Projectors && $data.TerminalInfo.Info.Projectors[0].State ? 0 : 1
                    )
                  ))
                          }, " 投影一 ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[1].State &&
                    ($data.TerminalInfo.Info.Projectors[1].State === 1 || $data.TerminalInfo.Info.Projectors[1].State === 'On')
                      ? 'active'
                      : ''
                  ]),
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (
                    $options.Control(
                      'projectorer2',
                      $data.TerminalInfo.Info && $data.TerminalInfo.Info.Projectors && $data.TerminalInfo.Info.Projectors[1].State ? 0 : 1
                    )
                  ))
                          }, " 投影二 ", 2)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.PanelLock === 1 || $data.TerminalInfo.Info.PanelLock === 'On')
                    ? 'active'
                    : ''
                ]),
                          onClick: _cache[19] || (_cache[19] = ($event: any) => ($options.Control('PanelLock', $data.TerminalInfo.Info.PanelLock ? 0 : 1)))
                        }, " 面板锁 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.ELock === 1 || $data.TerminalInfo.Info.ELock === 'On')
                    ? 'active'
                    : ''
                ]),
                          onClick: _cache[20] || (_cache[20] = ($event: any) => ($options.Control('E_Lock', $data.TerminalInfo.Info.ELock ? 0 : 1)))
                        }, " 讲台锁 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.Arming === 1 || $data.TerminalInfo.Info.Arming === 'On')
                    ? 'active'
                    : ''
                ]),
                          onClick: _cache[21] || (_cache[21] = ($event: any) => ($options.Control('Arming', $data.TerminalInfo.Info.Arming ? 0 : 1)))
                        }, " 中控警报 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.Guard === 1 || $data.TerminalInfo.Info.Guard === 'On')
                    ? 'active'
                    : ''
                ]),
                          onClick: _cache[22] || (_cache[22] = ($event: any) => ($options.Control('Guard', $data.TerminalInfo.Info.Guard ? 0 : 1)))
                        }, " 门禁 ", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 0 ? 'active' : '']),
                          onClick: _cache[23] || (_cache[23] = ($event: any) => ($options.Control('VI_0')))
                        }, " 睿课终-主 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 1 ? 'active' : '']),
                          onClick: _cache[24] || (_cache[24] = ($event: any) => ($options.Control('VI_1')))
                        }, " 睿课终-副 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 2 ? 'active' : '']),
                          onClick: _cache[25] || (_cache[25] = ($event: any) => ($options.Control('VI_2')))
                        }, " PC-HDMI ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 3 ? 'active' : '']),
                          onClick: _cache[26] || (_cache[26] = ($event: any) => ($options.Control('VI_3')))
                        }, " PC-VGA ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 4 ? 'active' : '']),
                          onClick: _cache[27] || (_cache[27] = ($event: any) => ($options.Control('VI_4')))
                        }, _hoisted_39, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 5 ? 'active' : '']),
                          onClick: _cache[28] || (_cache[28] = ($event: any) => ($options.Control('VI_5')))
                        }, _hoisted_42, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 6 ? 'active' : '']),
                          onClick: _cache[29] || (_cache[29] = ($event: any) => ($options.Control('VI_6')))
                        }, " 拓展一 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 7 ? 'active' : '']),
                          onClick: _cache[30] || (_cache[30] = ($event: any) => ($options.Control('VI_7')))
                        }, " 拓展二 ", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", {
                          class: "item-option",
                          onClick: _cache[31] || (_cache[31] = ($event: any) => ($options.Control('VO_ALL_' + $data.TerminalInfo.Info.VideoSource)))
                        }, "全部"),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoSource === $data.TerminalInfo.Info.VideoOuts[0] &&
                  $data.TerminalInfo.Info.VideoOuts[0] !== 100
                    ? 'active'
                    : ''
                ]),
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (
                  $options.Control(
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === $data.TerminalInfo.Info.VideoOuts[0]
                      ? 'VO_23_0'
                      : 'VO_23_1'
                  )
                ))
                        }, " 大屏一 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoSource === $data.TerminalInfo.Info.VideoOuts[1] &&
                  $data.TerminalInfo.Info.VideoOuts[1] !== 100
                    ? 'active'
                    : ''
                ]),
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (
                  $options.Control(
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === $data.TerminalInfo.Info.VideoOuts[1]
                      ? 'VO_24_0'
                      : 'VO_24_1'
                  )
                ))
                        }, " 大屏一 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoSource === $data.TerminalInfo.Info.VideoOuts[2] &&
                  $data.TerminalInfo.Info.VideoOuts[2] !== 100
                    ? 'active'
                    : ''
                ]),
                          onClick: _cache[34] || (_cache[34] = ($event: any) => (
                  $options.Control(
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === $data.TerminalInfo.Info.VideoOuts[2]
                      ? 'VO_25_0'
                      : 'VO_25_1'
                  )
                ))
                        }, " 显示器 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info &&
                  $data.TerminalInfo.Info.VideoSource === $data.TerminalInfo.Info.VideoOuts[3] &&
                  $data.TerminalInfo.Info.VideoOuts[3] !== 100
                    ? 'active'
                    : ''
                ]),
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (
                  $options.Control(
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === $data.TerminalInfo.Info.VideoOuts[3]
                      ? 'VO_26_0'
                      : 'VO_26_1'
                  )
                ))
                        }, " 录播互动 ", 2)
                      ])
                    ]),
                    ($data.Powers.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Powers, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item-option", item.Value === 'On' || item.Value === 1 ? 'active' : '']),
                                key: index,
                                onClick: 
                  () =>
                    item.ID === 11 || item.ID === 23 || item.ID === 24 || item.ID === 53 || item.ID === 54
                      ? null
                      : $options.Control(`Power_${item.ID}`, item.Value ? 0 : 1)
                
                              }, _toDisplayString(item.Name), 11, _hoisted_49))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600BG')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 3 || $data.TerminalInfo.Info.State === 'Opened')
                      ? 'active'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 2 || $data.TerminalInfo.Info.State === 'Opening')
                      ? 'active-ing'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 0 || $data.TerminalInfo.Info.State === 'Shutdown')
                      ? 'unActive'
                      : ''
                  ]),
                              onClick: _cache[36] || (_cache[36] = ($event: any) => ($options.Control('sceneOnClass')))
                            }, " 上课 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 1 || $data.TerminalInfo.Info.State === 'ShuttingDown')
                      ? 'active-ing'
                      : ''
                  ]),
                              onClick: _cache[37] || (_cache[37] = ($event: any) => ($options.Control('sceneOffClass')))
                            }, " 下课 ", 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0].State &&
                    ($data.TerminalInfo.Info.Projectors[0].State === 1 || $data.TerminalInfo.Info.Projectors[0].State === 'On')
                      ? 'active'
                      : ''
                  ]),
                              onClick: _cache[38] || (_cache[38] = ($event: any) => (
                    $options.Control(
                      'projectorer1',
                      $data.TerminalInfo.Info && $data.TerminalInfo.Info.Projectors && $data.TerminalInfo.Info.Projectors[0].State ? 0 : 1
                    )
                  ))
                            }, " 投影一 ", 2)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.PanelLock === 1 || $data.TerminalInfo.Info.PanelLock === 'On')
                    ? 'active'
                    : ''
                ]),
                            onClick: _cache[39] || (_cache[39] = ($event: any) => ($options.Control('PanelLock', $data.TerminalInfo.Info.PanelLock ? 0 : 1)))
                          }, " 面板锁 ", 2)
                        ])
                      ]),
                      ($data.Powers.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _hoisted_62,
                            _createElementVNode("div", _hoisted_63, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Powers, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["item-option", item.Value === 'On' || item.Value === 1 ? 'active' : '']),
                                  key: index,
                                  onClick: 
                  () =>
                    item.ID === 11 || item.ID === 23 || item.ID === 24 || item.ID === 53 || item.ID === 54
                      ? null
                      : $options.Control(`Power_${item.ID}`, item.Value ? 0 : 1)
                
                                }, _toDisplayString(item.Name), 11, _hoisted_64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600XX')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _hoisted_68,
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 3 || $data.TerminalInfo.Info.State === 'Opened')
                      ? 'active'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 2 || $data.TerminalInfo.Info.State === 'Opening')
                      ? 'active-ing'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 0 || $data.TerminalInfo.Info.State === 'Shutdown')
                      ? 'unActive'
                      : ''
                  ]),
                                onClick: _cache[40] || (_cache[40] = ($event: any) => ($options.Control('sceneOnClass')))
                              }, " 上课 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 1 || $data.TerminalInfo.Info.State === 'ShuttingDown')
                      ? 'active-ing'
                      : ''
                  ]),
                                onClick: _cache[41] || (_cache[41] = ($event: any) => ($options.Control('sceneOffClass')))
                              }, " 下课 ", 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _hoisted_71,
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0].State &&
                    ($data.TerminalInfo.Info.Projectors[0].State === 1 || $data.TerminalInfo.Info.Projectors[0].State === 'On')
                      ? 'active'
                      : ''
                  ]),
                                onClick: _cache[42] || (_cache[42] = ($event: any) => (
                    $options.Control(
                      'projectorer1',
                      $data.TerminalInfo.Info && $data.TerminalInfo.Info.Projectors && $data.TerminalInfo.Info.Projectors[0].State ? 0 : 1
                    )
                  ))
                              }, " 投影一 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[1].State &&
                    ($data.TerminalInfo.Info.Projectors[1].State === 1 || $data.TerminalInfo.Info.Projectors[1].State === 'On')
                      ? 'active'
                      : ''
                  ]),
                                onClick: _cache[43] || (_cache[43] = ($event: any) => (
                    $options.Control(
                      'projectorer2',
                      $data.TerminalInfo.Info && $data.TerminalInfo.Info.Projectors && $data.TerminalInfo.Info.Projectors[1].State ? 0 : 1
                    )
                  ))
                              }, " 投影二 ", 2)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.PanelLock === 1 || $data.TerminalInfo.Info.PanelLock === 'On')
                    ? 'active'
                    : ''
                ]),
                              onClick: _cache[44] || (_cache[44] = ($event: any) => ($options.Control('PanelLock', $data.TerminalInfo.Info.PanelLock ? 0 : 1)))
                            }, " 面板锁 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.ELock === 1 || $data.TerminalInfo.Info.ELock === 'On')
                    ? 'active'
                    : ''
                ]),
                              onClick: _cache[45] || (_cache[45] = ($event: any) => ($options.Control('E_Lock', $data.TerminalInfo.Info.ELock ? 0 : 1)))
                            }, " 讲台锁 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.Arming === 1 || $data.TerminalInfo.Info.Arming === 'On')
                    ? 'active'
                    : ''
                ]),
                              onClick: _cache[46] || (_cache[46] = ($event: any) => ($options.Control('Arming', $data.TerminalInfo.Info.Arming ? 0 : 1)))
                            }, " 终端报警 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.Guard === 1 || $data.TerminalInfo.Info.Guard === 'On')
                    ? 'active'
                    : ''
                ]),
                              onClick: _cache[47] || (_cache[47] = ($event: any) => ($options.Control('Guard', $data.TerminalInfo.Info.Guard ? 0 : 1)))
                            }, " 门禁 ", 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoScene === 1 ? 'active' : '']),
                              onClick: _cache[48] || (_cache[48] = ($event: any) => ($options.Control('VS_1')))
                            }, " 电脑 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoScene === 2 ? 'active' : '']),
                              onClick: _cache[49] || (_cache[49] = ($event: any) => ($options.Control('VS_2')))
                            }, " 笔记本 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoScene === 3 ? 'active' : '']),
                              onClick: _cache[50] || (_cache[50] = ($event: any) => ($options.Control('VS_3')))
                            }, " 无线投屏 ", 2)
                          ])
                        ]),
                        ($data.TerminalInfo.Info && $data.TerminalInfo.Info.AsyncDisplays)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                              _hoisted_80,
                              _createElementVNode("div", _hoisted_81, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.TerminalInfo.Info.AsyncDisplays, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(["item-option", $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoScene === item.ID ? 'active' : '']),
                                    key: index,
                                    onClick: ($event: any) => ($options.Control('VS_' + item.ID))
                                  }, _toDisplayString(item.Name), 11, _hoisted_82))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : ($data.TerminalInfo.DeviceInfo.BrandCode === 'JYD')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _hoisted_85,
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 3 || $data.TerminalInfo.Info.State === 'Opened')
                    ? 'active'
                    : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 2 || $data.TerminalInfo.Info.State === 'Opening')
                    ? 'active-ing'
                    : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 0 || $data.TerminalInfo.Info.State === 'Shutdown')
                    ? 'unActive'
                    : ''
                ]),
                                onClick: _cache[51] || (_cache[51] = ($event: any) => ($options.Control('sceneOnClass')))
                              }, " 上课 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 1 || $data.TerminalInfo.Info.State === 'ShuttingDown')
                    ? 'active-ing'
                    : ''
                ]),
                                onClick: _cache[52] || (_cache[52] = ($event: any) => ($options.Control('sceneOffClass')))
                              }, " 下课 ", 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _hoisted_88,
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[53] || (_cache[53] = ($event: any) => ($options.Control('ProjectorOpen')))
                              }, "投影仪开"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[54] || (_cache[54] = ($event: any) => ($options.Control('ProjectorOff')))
                              }, "投影仪关"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[55] || (_cache[55] = ($event: any) => ($options.Control('Projector_RGB')))
                              }, "RGB"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[56] || (_cache[56] = ($event: any) => ($options.Control('Projector_Video')))
                              }, "Video")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _hoisted_91,
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[57] || (_cache[57] = ($event: any) => ($options.Control('Control_UnLock')))
                              }, "解锁中控"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[58] || (_cache[58] = ($event: any) => ($options.Control('Control_Lock')))
                              }, "锁定中控"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[59] || (_cache[59] = ($event: any) => ($options.Control('E_UnLock')))
                              }, "电子锁开"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[60] || (_cache[60] = ($event: any) => ($options.Control('E_Lock')))
                              }, "电子锁关"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[61] || (_cache[61] = ($event: any) => ($options.Control('Control_Arming')))
                              }, "报警布防"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[62] || (_cache[62] = ($event: any) => ($options.Control('Control_Disarmed')))
                              }, "报警撤防")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_93, [
                            _hoisted_94,
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[63] || (_cache[63] = ($event: any) => ($options.Control('Projector_PC')))
                              }, "台式机"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[64] || (_cache[64] = ($event: any) => ($options.Control('Projector_Laptop')))
                              }, "笔记本"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[65] || (_cache[65] = ($event: any) => ($options.Control('Projector_Booth')))
                              }, "数字展台"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[66] || (_cache[66] = ($event: any) => ($options.Control('Projector_Gateway')))
                              }, "互动网关"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[67] || (_cache[67] = ($event: any) => ($options.Control('Projector_Reserve')))
                              }, "备用")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _hoisted_97,
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[68] || (_cache[68] = ($event: any) => ($options.Control('AVOut_VCR')))
                              }, "录像机"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[69] || (_cache[69] = ($event: any) => ($options.Control('AVOut_DVD')))
                              }, "DVD"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[70] || (_cache[70] = ($event: any) => ($options.Control('AVOut_Booth')))
                              }, "实物展台"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[71] || (_cache[71] = ($event: any) => ($options.Control('AVOut_Control')))
                              }, "中控"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[72] || (_cache[72] = ($event: any) => ($options.Control('AVOut_Speaker')))
                              }, "话筒"),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[73] || (_cache[73] = ($event: any) => ($options.Control('Projector_Reserve')))
                              }, "备用")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _hoisted_100,
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && $data.TerminalInfo.Info.PowerInfos && $data.TerminalInfo.Info.PowerInfos[0] === 'On'
                    ? 'active'
                    : ''
                ]),
                                onClick: _cache[74] || (_cache[74] = ($event: any) => ($options.Control('CurtainRose')))
                              }, " 升起 ", 2),
                              _createElementVNode("div", {
                                class: "item-option",
                                onClick: _cache[75] || (_cache[75] = ($event: any) => ($options.Control('CurtainStop')))
                              }, "停止"),
                              _createElementVNode("div", {
                                class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && $data.TerminalInfo.Info.PowerInfos && $data.TerminalInfo.Info.PowerInfos[0] === 'Off'
                    ? 'active'
                    : ''
                ]),
                                onClick: _cache[76] || (_cache[76] = ($event: any) => ($options.Control('CurtainDown')))
                              }, " 降落 ", 2)
                            ])
                          ])
                        ]))
                      : ($data.TerminalInfo.DeviceInfo.BrandCode === 'ECHOR')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                            _createElementVNode("div", _hoisted_103, [
                              _createElementVNode("div", _hoisted_104, [
                                _hoisted_105,
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 3 || $data.TerminalInfo.Info.State === 'Opened')
                      ? 'active'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 2 || $data.TerminalInfo.Info.State === 'Opening')
                      ? 'active-ing'
                      : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 0 || $data.TerminalInfo.Info.State === 'Shutdown')
                      ? 'unActive'
                      : ''
                  ]),
                                    onClick: _cache[77] || (_cache[77] = ($event: any) => ($options.Control('sceneOnClass')))
                                  }, " 上课 ", 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 1 || $data.TerminalInfo.Info.State === 'ShuttingDown')
                      ? 'active-ing'
                      : ''
                  ]),
                                    onClick: _cache[78] || (_cache[78] = ($event: any) => ($options.Control('sceneOffClass')))
                                  }, " 下课 ", 2)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_107, [
                                _hoisted_108,
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0] &&
                    $data.TerminalInfo.Info.Projectors[0] === 'On'
                      ? 'active'
                      : ''
                  ]),
                                    onClick: _cache[79] || (_cache[79] = ($event: any) => ($options.Control('ProjectorOpen')))
                                  }, " 投影仪开 ", 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["item-option", 
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0] &&
                    $data.TerminalInfo.Info.Projectors[0] === 'Off'
                      ? 'active'
                      : ''
                  ]),
                                    onClick: _cache[80] || (_cache[80] = ($event: any) => ($options.Control('ProjectorOff')))
                                  }, " 投影仪关 ", 2)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_110, [
                              _hoisted_111,
                              _createElementVNode("div", _hoisted_112, [
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[81] || (_cache[81] = ($event: any) => ($options.Control('E_UnLock')))
                                }, "讲台锁开"),
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[82] || (_cache[82] = ($event: any) => ($options.Control('E_Lock')))
                                }, "讲台锁关"),
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[83] || (_cache[83] = ($event: any) => ($options.Control('Control_UnLock')))
                                }, "解锁面板"),
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[84] || (_cache[84] = ($event: any) => ($options.Control('Control_Lock')))
                                }, "锁定面板")
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_113, [
                              _hoisted_114,
                              _createElementVNode("div", _hoisted_115, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && $data.TerminalInfo.Info.PowerInfos && $data.TerminalInfo.Info.PowerInfos[1] === 'On'
                    ? 'active'
                    : ''
                ]),
                                  onClick: _cache[85] || (_cache[85] = ($event: any) => ($options.Control('Power_PC_Open')))
                                }, " 开启电脑 ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && $data.TerminalInfo.Info.PowerInfos && $data.TerminalInfo.Info.PowerInfos[1] === 'Off'
                    ? 'active'
                    : ''
                ]),
                                  onClick: _cache[86] || (_cache[86] = ($event: any) => ($options.Control('Power_PC_Off')))
                                }, " 关闭电脑 ", 2)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                              _hoisted_117,
                              _createElementVNode("div", _hoisted_118, [
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[87] || (_cache[87] = ($event: any) => ($options.Control('PS_Computer')))
                                }, "电脑"),
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[88] || (_cache[88] = ($event: any) => ($options.Control('PS_Notepad')))
                                }, "笔记本"),
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[89] || (_cache[89] = ($event: any) => ($options.Control('PS_Video3')))
                                }, "视频三"),
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[90] || (_cache[90] = ($event: any) => ($options.Control('PS_Video4')))
                                }, "视频四")
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_119, [
                              _hoisted_120,
                              _createElementVNode("div", _hoisted_121, [
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[91] || (_cache[91] = ($event: any) => ($options.Control('CurtainRose')))
                                }, "关投影幕"),
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[92] || (_cache[92] = ($event: any) => ($options.Control('CurtainDown')))
                                }, "开投影幕")
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_122, [
                              _hoisted_123,
                              _createElementVNode("div", _hoisted_124, [
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[93] || (_cache[93] = ($event: any) => ($options.Control('PlusSoundVolume')))
                                }, "音频加"),
                                _createElementVNode("div", {
                                  class: "item-option",
                                  onClick: _cache[94] || (_cache[94] = ($event: any) => ($options.Control('MinusSoundVolume')))
                                }, "音频减")
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_125, [
                            _createElementVNode("div", _hoisted_126, [
                              _hoisted_127,
                              _createElementVNode("div", _hoisted_128, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 3 || $data.TerminalInfo.Info.State === 'Opened')
                    ? 'active'
                    : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 2 || $data.TerminalInfo.Info.State === 'Opening')
                    ? 'active-ing'
                    : $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 0 || $data.TerminalInfo.Info.State === 'Shutdown')
                    ? 'unActive'
                    : ''
                ]),
                                  onClick: _cache[95] || (_cache[95] = ($event: any) => ($options.Control('sceneOnClass')))
                                }, " 上课 ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["item-option", 
                  $data.TerminalInfo.Info && ($data.TerminalInfo.Info.State === 1 || $data.TerminalInfo.Info.State === 'ShuttingDown')
                    ? 'active-ing'
                    : ''
                ]),
                                  onClick: _cache[96] || (_cache[96] = ($event: any) => ($options.Control('sceneOffClass')))
                                }, " 下课 ", 2)
                              ])
                            ])
                          ]))
          ]))
        : _createCommentVNode("", true),
      ($data.cur == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.IOTCounts, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "internet-cont",
                key: index
              }, [
                (item.total > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                      _createElementVNode("div", _hoisted_131, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["iconfont", item.using > 0 || _ctx.cur_IOT == index ? item.icon + ' active-color' : item.icon])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_132, [
                          _createElementVNode("div", _hoisted_133, _toDisplayString(item.name), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["fs24", item.using > 0 || _ctx.cur_IOT == index ? 'active-color' : ''])
                          }, _toDisplayString(item.using) + "/" + _toDisplayString(item.total) + "设备在工作 ", 3)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_134, [
                        _createElementVNode("div", {
                          class: _normalizeClass(item.operate == 'open' ? 'item-active' : ''),
                          onClick: ($event: any) => ($options.operatOpen(index, 'open'))
                        }, "全开", 10, _hoisted_135),
                        _createElementVNode("div", {
                          class: _normalizeClass(item.operate == 'close' ? 'item-active' : ''),
                          onClick: ($event: any) => ($options.operatOpen(index, 'close'))
                        }, "全关", 10, _hoisted_136)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      ($data.cur == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _hoisted_139,
              _createElementVNode("div", _hoisted_140, [
                ($data.sensorInfo.tem)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                      _createElementVNode("div", null, "温度:" + _toDisplayString($data.sensorInfo.tem.value) + "℃", 1)
                    ]))
                  : _createCommentVNode("", true),
                ($data.sensorInfo.hum)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                      _createElementVNode("div", null, "湿度:" + _toDisplayString($data.sensorInfo.hum.value) + "%", 1)
                    ]))
                  : _createCommentVNode("", true),
                ($data.sensorInfo.pm25)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                      _createElementVNode("div", null, "PM2.5:" + _toDisplayString($data.sensorInfo.pm25.value) + "μg/m3", 1)
                    ]))
                  : _createCommentVNode("", true),
                ($data.sensorInfo.co)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                      _createElementVNode("div", null, "CO2:" + _toDisplayString($data.sensorInfo.co.value) + "PPM", 1)
                    ]))
                  : _createCommentVNode("", true),
                ($data.sensorInfo.lux)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                      _createElementVNode("div", null, "光照度:" + _toDisplayString($data.sensorInfo.lux.value) + "LUX", 1)
                    ]))
                  : _createCommentVNode("", true),
                ($data.sensorInfo.tvoc)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                      _createElementVNode("div", null, "TVOC:" + _toDisplayString($data.sensorInfo.tvoc.value) + "μg/m3", 1)
                    ]))
                  : _createCommentVNode("", true),
                ($data.sensorInfo.pm10)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                      _createElementVNode("div", null, "PM10:" + _toDisplayString($data.sensorInfo.pm10.value) + "μg/m3", 1)
                    ]))
                  : _createCommentVNode("", true),
                ($data.sensorInfo.ch20)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                      _createElementVNode("div", null, "甲醛:" + _toDisplayString($data.sensorInfo.ch20.value) + "μg/m3", 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($data.cur == 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
            _createVNode(_component_Guard, {
              Cid: $data.curId,
              guardInfo: $data.guardInfo,
              IOTDoorLock: $data.IOTDoorLock
            }, null, 8, ["Cid", "guardInfo", "IOTDoorLock"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}